import React, { useState, useContext, useEffect } from "react";
import pumpBackgroundGlow from "../resources/btn_background_blue_glow_circle.png";
import pumpFan from "../resources/icon_pump_fan.png";
import pumpConfig from "../resources/icon_config.png";
import { MainContext } from "../../context/MainContext";

import PumpSingleSpeedModal from "./PumpSingleSpeedModal";
import PumpTwoSpeedModal from "./PumpTwoSpeedModal";
import PumpVariableSpeedModal from "./PumpVariableSpeedModal";
import PumpVariableTurbineSpeedModal from "./PumpVariableTurbineSpeedModal";
import PumpVariableSpeedSliderModal from "./PumpVariableSpeedSliderModal";
import PumpVariableTurbineSpeedSliderModal from "./PumpVariableTurbineSpeedSliderModal";
import BlowerModal from "./BlowerModal";

import * as Constants from "../../components/api/constants";
import { ToastContainer, toast } from "react-toastify";

import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

let deviceId = 0;

const ControlPumps = () => {
  const state = useContext(MainContext).state;
  deviceId = state.selectedDevice;

  let r4 = state.R4.split(",");
  let r5 = state.R5.split(",");
  let rg = state.RG.split(",");

  const [connectedPumps, setConnectedPumps] = useState([]);
  const [selectedPump, setSelectedPump] = useState(null);

  useEffect(() => {
    const deviceId = state.selectedDevice;
    const r4 = state.R4.split(",");
    const r5 = state.R5.split(",");
    const rg = state.RG.split(",");

    const newPumps = [];

    // Fix RG defaults
    if (
      rg.length > 11 &&
      rg[7] === "0-" &&
      rg[8] === "0-" &&
      rg[9] === "0-" &&
      rg[10] === "0-" &&
      rg[11] === "0-"
    ) {
      rg[8] = "1-1-014";
      rg[9] = "1-1-01";
      rg[10] = "1-1-01";
    }

    if (getNumberOfConnectedPumps(rg[8], rg[9], rg[10], rg[11]) < 4) {
      if (isPumpConnected(rg[7])) {
        const speedId = getPumpSpeedId(rg[7]);
        const modeId =
          speedId === 3 || speedId === 6 ? getVariablePumpMode(r4[28]) : getPumpMode(r5[18]);

        newPumps.push(
          pumpData(
            -1,
            speedId,
            modeId,
            getHasAuto(rg[7]),
            r4[24],
            rg[2] === "1"
          )
        );
      }
    }

    if (isPumpConnected(rg[8])) {
      const speedId = getPumpSpeedId(rg[8]);
      const modeId =
        speedId === 3 || speedId === 6 ? getVariablePumpMode(r4[28]) : getPumpMode(r5[19]);

      newPumps.push(
        pumpData(
          1,
          speedId,
          modeId,
          getHasAuto(rg[8]),
          r4[24],
          rg[3] === "1"
        )
      );
    }

    if (isPumpConnected(rg[9])) {
      const speedId = getPumpSpeedId(rg[9]);
      const modeId =
        speedId === 3 || speedId === 6 ? getVariablePumpMode(r4[28]) : getPumpMode(r5[20]);

      newPumps.push(
        pumpData(
          2,
          speedId,
          modeId,
          getHasAuto(rg[9]),
          r4[26],
          rg[3] === "1"
        )
      );
    }

    if (isPumpConnected(rg[10])) {
      const speedId = getPumpSpeedId(rg[10]);
      const modeId =
        speedId === 3 || speedId === 6 ? getVariablePumpMode(r4[28]) : getPumpMode(r5[21]);

      newPumps.push(
        pumpData(
          3,
          speedId,
          modeId,
          getHasAuto(rg[10]),
          r4[26],
          rg[4] === "1"
        )
      );
    }

    if (isPumpConnected(rg[11])) {
      const speedId = getPumpSpeedId(rg[11]);
      const modeId =
        speedId === 3 || speedId === 6 ? getVariablePumpMode(r4[28]) : getPumpMode(r5[22]);

      newPumps.push(
        pumpData(
          4,
          speedId,
          modeId,
          getHasAuto(rg[11]),
          r4[27],
          rg[5] === "1"
        )
      );
    }

    setConnectedPumps(newPumps);
  }, [state.RG, state.R4, state.R5]);

  function getNumberOfConnectedPumps(rg8, rg9, rg10, rg11) {
    const pumpStateList = [rg8, rg9, rg10, rg11];

    return pumpStateList.filter((x) => {
      if (typeof x !== "string" || !x.includes("-")) return false;
      const parts = x.split("-");
      return parts.length > 1 && parts[1] === "1";
    }).length;
  }

  function isPumpConnected(state) {
    if (state[0] == "1") return true;
    return false;
  }

  function pumpData(
    pumpNumber,
    pumpSpeedId,
    pumpModeId,
    hasAuto,
    pumpVariableSpeed,
    canSwitchOn
  ) {
    return {
      pumpNumber,
      pumpSpeedId,
      pumpModeId,
      hasAuto,
      pumpVariableSpeed,
      canSwitchOn,
    };
  }

  const getPumpMode = (value) => {
    value = Number(value);
    var id = 0;

    switch (value) {
      case 0:
        id = 2;
        break;
      case 1:
        id = 1;
        break;
      case 2:
        id = 5;
        break;
      case 3:
        id = 6;
        break;
      case 4:
        id = 3;
        break;
    }
    return id;
  };

  const getVariablePumpMode = (value) => {
    value = Number(value);
    var id = 0;

    switch (value) {
      case 0:
        id = 4;
        break;
      case 1:
        id = 7;
        break;
      case 2:
        id = 8;
        break;
      case 3:
        id = 9;
        break;
      case 4:
        id = 2;
        break;
      case 5:
        id = 3;
        break;
      case 6:
        id = 1;
        break;
      case 7:
        id = 1;
        break;
      default:
        id = 1;
        break;
    }

    return id;
  };

  function getPumpSpeedId(state) {
    const pumpSpeeds = [
      { id: 1, speed: 1 },
      { id: 2, speed: 2 },
      { id: 3, speed: 3 },
      { id: 4, speed: -1 },
      { id: 5, speed: -2 },
      { id: 6, speed: 4 },
    ];

    try {
      if (!state) return 0;
      if (state.length === 1) return 5;

      const parts = state.split("-");
      if (parts.length < 2) return 0;

      const speed = parseInt(parts[1], 10);
      if (isNaN(speed)) return 0;

      const pumpSpeed = pumpSpeeds.find((x) => x.speed === speed);
      return pumpSpeed ? pumpSpeed.id : 0;
    } catch (e) {
      console.error(`GetPumpSpeedId - State: ${state}`, e);
      return 0;
    }
  }

  function getHasAuto(state) {
    if (!state) return false;
    const parts = state.split("-");
    return parts.length > 2 && parts[2].includes("4");
  }

  const numberToLetter = (n) => {
    var hasNegativeOne = connectedPumps.some((p) => p.pumpNumber === -1);
    if (hasNegativeOne) {
      if (n === -1) return "A";
      n = n + 1;
    }
    if (n >= 1 && n <= 26) return String.fromCharCode(64 + n);
    if (n === 0) return "A";
    return "";
  };

  const renderPumpModal = () => {
    if (!selectedPump) return null;

    const hasNegativeOne = connectedPumps.some((p) => p.pumpNumber === -1);
    const pumpName = `Pump ${numberToLetter(
      selectedPump.pumpNumber,
      hasNegativeOne
    )}`;
    const closeModal = () => setSelectedPump(null);

    switch (selectedPump.pumpSpeedId) {
      case 1:
      case 4:
      case 5:
        if (!selectedPump.hasAuto) {
          sendPumpCommand(
            selectedPump.pumpNumber,
            selectedPump.pumpModeId == 1 ? "off" : "on"
          );
          setSelectedPump(null);
          return null;
        }
        return (
          <PumpSingleSpeedModal
            pumpName={pumpName}
            pumpNumber={selectedPump.pumpNumber}
            pumpStatus={selectedPump.pumpModeId}
            hasAuto={selectedPump.hasAuto}
            sendPumpCommand={sendPumpCommand}
            onClose={closeModal}
          />
        );

      case 2:
        return (
          <PumpTwoSpeedModal
            pumpName={pumpName}
            pumpNumber={selectedPump.pumpNumber}
            pumpStatus={selectedPump.pumpModeId}
            hasAuto={selectedPump.hasAuto}
            sendPumpCommand={sendPumpCommand}
            onClose={closeModal}
          />
        );

      case 3:
        return (
          <PumpVariableSpeedModal
            pumpName={pumpName}
            pumpNumber={selectedPump.pumpNumber}
            pumpStatus={selectedPump.pumpModeId}
            hasAuto={selectedPump.hasAuto}
            pumpVariableSpeed={selectedPump.pumpVariableSpeed}
            sendPumpCommand={sendPumpCommand}
            onClose={closeModal}
          />
        );

      case 6:
        return (
          <PumpVariableTurbineSpeedModal
            pumpName={pumpName}
            pumpNumber={selectedPump.pumpNumber}
            pumpStatus={selectedPump.pumpModeId}
            hasAuto={selectedPump.hasAuto}
            pumpVariableSpeed={selectedPump.pumpVariableSpeed}
            sendPumpCommand={sendPumpCommand}
            onClose={closeModal}
          />
        );

      default:
        return null;
    }
  };

  const sendPumpCommand = (pumpNumber, mode, variableSpeed = 0) => {
    const body = {
      DeviceId: deviceId,
      PumpNumber: pumpNumber,
      Mode: mode,
    };

    if (variableSpeed !== 0) {
      body.PumpVariableSpeed = variableSpeed;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      credentials: "include",
    };

    fetch(Constants.baseURL + Constants.apiSendPumpCommand, requestOptions)
      .then((response) => {
        if (response.ok) {
          toast.success("Command sent successfully. Refreshing...", {
            position: "top-right",
            autoClose: 12000,
          });

          setTimeout(() => state.refreshDeviceRF(deviceId), 8000);
          setTimeout(() => state.getUserDeviceRf(deviceId), 12000);
        } else {
          toast.error("Send failed. Please try again", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      })
      .catch((error) => console.log("request failed", error));
  };

  const isPumpOn = (pump) => pump.pumpModeId !== 2;

  const pumpSpinSpeeds = {
    1: 1500,
    2: 1000,
    3: 700,
    4: 1500,
    5: 1500,
  };

  const getSpinSpeed = (pump) => {
    if (!isPumpOn(pump)) return 0;
    return pumpSpinSpeeds[pump.pumpSpeedId] || 1500;
  };

  return (
    <>
      <ToastContainer />

      <Typography
        component="h2"
        variant="h6"
        sx={{ color: "white", fontWeight: 600, mb: 1 }}
      >
        Pumps
      </Typography>

      <Paper
        sx={{
          p: 3,
          borderRadius: 2,
          bgcolor: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.08)",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 4,
            width: "100%",
          }}
        >
          {connectedPumps.map((pump, index) => {
            const spinSpeed = getSpinSpeed(pump);
            const isOn = !!spinSpeed;
            const isAuto = pump.pumpModeId == 3;

            return (
              <div
                key={index}
                onClick={() => setSelectedPump(pump)}
                style={{
                  width: "60px",
                  height: "60px",
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  borderRadius: "50%",
                  border: isOn ? "" : "2px solid #2f3338",
                  backgroundColor: "transparent",
                  transition: "all 0.2s ease",
                }}
              >
                {(isOn || isAuto) && (
                  <img
                    src={pumpBackgroundGlow}
                    alt="Pump glow"
                    style={{
                      width: "80px",
                      height: "80px",
                      position: "absolute",
                      objectFit: "contain",
                    }}
                  />
                )}

                <img
                  src={pumpFan}
                  alt="Pump icon"
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    animation:
                      isAuto
                        ? "none"
                        : spinSpeed
                          ? `spin-${index} ${spinSpeed}ms linear infinite`
                          : "none",
                  }}
                />

                {(pump.pumpSpeedId === 2 ||
                  pump.pumpSpeedId === 3 ||
                  pump.hasAuto) && (
                    <div
                      style={{
                        position: "absolute",
                        top: "-1px",
                        right: "-1px",
                        width: "23px",
                        height: "23px",
                        borderRadius: "50%",
                        backgroundColor: "#1E1E1E",
                        border: "2px solid #2B333C",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={pumpConfig}
                        alt="Settings"
                        style={{ width: "12px", height: "12px" }}
                      />
                    </div>
                  )}

                <style>
                  {`
                    @keyframes spin-${index} {
                      from { transform: translate(-50%, -50%) rotate(0deg); }
                      to { transform: translate(-50%, -50%) rotate(360deg); }
                    }
                  `}
                </style>
              </div>
            );
          })}
        </Box>
      </Paper>

      {renderPumpModal()}
    </>
  );
};

export default ControlPumps;
